module.exports = __webpack_public_path__ + "img/visa.fefb7e5.png";